import styles from './SolutionPickerModule.scss';

import cx from 'classnames';
import { ReferencedEntry } from 'contentful';
import React, { FC, HTMLAttributes } from 'react';

import { SolutionPickerModule as SolutionPickerModuleType } from 'src/api/contentful/contentTypes.cloverdotcom';
import { ContentImage } from 'src/components/ContentImage/ContentImage';
import { ContentLinkV2 } from 'src/components/ContentLinkV2/ContentLinkV2';
import { Grid } from 'src/components/Grid/Grid';
import { GridContainer } from 'src/components/GridContainer/GridContainer';
import { TextV2 } from 'src/components/TextV2/TextV2';
import { FlatEntry, flattenContentfulData } from 'src/services/cms/flattenContentful';

interface SolutionPickerModuleProps extends HTMLAttributes<HTMLElement> {
  entry?: FlatEntry<SolutionPickerModuleType>;
}

const SolutionPickerModule: FC<SolutionPickerModuleProps> = ({
  entry,
  style = {},
  className,
  ...props
}) => {
  if (!entry) return null;
  const { backgroundColor, items = [], title, titleColor, subTitle, subTitleColor, isUsedWithEmptyCartPage } = entry;

  return (
    <section
      className={cx(styles.solutionPickerModule, className)}
      style={{ ...style, backgroundColor: backgroundColor || style.backgroundColor }}
      {...props}
    >
      <GridContainer justifyContent="center">
        <Grid item xs={12} md={9} lg={10} xl={8}>
          <div className={styles.solutionPickerModuleHero}>
            <TextV2 isMarkdown value={title} entry={{ ...entry, field: 'title' }} tagName="h1" variant={isUsedWithEmptyCartPage ? 'h1-medium' : 'h1'} className="title" style={{ color: titleColor }} />
            <TextV2 isMarkdown value={subTitle} entry={{ ...entry, field: 'subTitle' }} tagName={isUsedWithEmptyCartPage ? 'h4' : 'div'} variant="h4" className={styles.solutionPickerModuleSubTitle} style={{ color: subTitleColor }} />
          </div>
        </Grid>
      </GridContainer>
      {items.length && (
        <GridContainer
          justifyContent="center"
          maxWidth="lg"
          className={styles.solutionPickerModuleButtons}
        >
          <Grid container item xs={12} lg={10} xl={12} gutter>
            {items.map(item => {
              const { title: buttonTitle, image, link } = item;
              if (!buttonTitle || !image || !link) return null;

              return (
                <Grid key={buttonTitle} item xs={6} lg={4}>
                  <ContentLinkV2 entry={link} hideTitle className={styles.solutionPickerModuleButton}>
                    <ContentImage entry={image} className={styles.solutionPickerModuleButtonImage} />
                    <TextV2 value={buttonTitle} entry={{ ...item, field: 'title' }} tagName="div" variant="body" className={styles.solutionPickerModuleButtonText} />
                  </ContentLinkV2>
                </Grid>
              );
            })}
          </Grid>
        </GridContainer>
      )}
    </section>
  );
};

SolutionPickerModule.displayName = 'SolutionPickerModule';

interface SolutionPickerModuleWrapperProps extends HTMLAttributes<HTMLElement> {
  entry?: ReferencedEntry<SolutionPickerModuleType>;
}

const SolutionPickerModuleWrapper: FC<SolutionPickerModuleWrapperProps> = ({ entry, ...props }) =>
  React.createElement(SolutionPickerModule, { ...props, entry: flattenContentfulData(entry) });

SolutionPickerModuleWrapper.displayName = 'SolutionPickerModuleWrapper';

export {
  SolutionPickerModule as _SolutionPickerModule,
  SolutionPickerModuleWrapper as SolutionPickerModule,
};
